import { render, staticRenderFns } from "./MessageGalleryItem.vue?vue&type=template&id=79bd9633&scoped=true&"
import script from "./MessageGalleryItem.vue?vue&type=script&lang=ts&"
export * from "./MessageGalleryItem.vue?vue&type=script&lang=ts&"
import style0 from "./MessageGalleryItem.vue?vue&type=style&index=0&id=79bd9633&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bd9633",
  null
  
)

export default component.exports